import type { Language } from "../language/language";
import type { Locale } from "date-fns";
import { de, es, fr, it, nl, ptBR } from "date-fns/locale";
import { nb as no } from "date-fns/locale/nb";
import { enGB as en } from "date-fns/locale/en-GB";

export const dateFns_getLocaleFromLanguage = (language: Language): Locale => {
	switch (language) {
		case "nl":
			return nl;
		case "fr":
			return fr;
		case "no":
			return no;
		case "it":
			return it;
		case "de":
			return de;
		case "es":
			return es;
		case "pt-br":
			return ptBR;
		case "en":
		default:
			return en;
	}
};
